import React, { useState, useEffect, useContext, useSearchParams } from "react";
import { DatePicker, Select, TimePicker, message, notification } from "antd";
import { RENTACAR_CONSTANTS } from "./rentacarConstants";
import "./RentacarFilter.css";
import { VILLAGES_OBJ } from "../../constants/constants";
import { searchVehicles } from "./searchVehicles";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
// remover moment (apenas para testes com dados pré-preenchidos)
import moment from "moment";
import ClearStateBtn from "../../components/ClearStateBtn/ClearStateBtn";
import { AppContext } from "../../context";
import { timeRangeInDays } from "../../library/timeRangeInDays";
import { disabledDates } from "./lib/disabledDates";
import Sustainability from "../../components/Sustainability/Sustainability";
import { openkit } from "../../library/database";
import { useLocation } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import { timeRangeInHours } from "../../library/timeRangeInHours";

function RentacarFilter({ setProducts, setStores }) {
  const info = useContext(AppContext);
  const [carFilterParams, setCarFilterParams] = useState({});
  const [pickupLocation, setPickupLocation] = useState(null);
  const [pickupLocations, setPickupLocations] = useState(null);
  const [returnLocation, setReturnLocation] = useState(null);
  const [returnLocations, setReturnLocations] = useState(null);
  // pickupLocation and returnLocation, used to limit the villages of the other suggestions
  const [pickupAndReturn, setPickupAndReturn] = useState([null, null]);
  const [store, setStore] = useState(null);
  const [userCategoryMaxHours, setUserCategoryMaxHours] = useState({
    resident: 2,
    visitor: 4,
    company: 3,
    coworker: 1,
  });

  const { RangePicker } = DatePicker;
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  // useEffect(() => {
  //   // based on query parameters, fill carFilterParams
  //   let paramsStr = "?";
  //   for (const [key, value] of searchParams) {
  //     paramsStr += `${key}=${value}&`;
  //   }
  //   console.log("paramsStr :>> ", paramsStr);
  //   console.log("typology :>> ", searchParams?.get("typology"));

  //   setCarFilterParams({
  //     ...carFilterParams,
  //     typology: searchParams?.get("typology"),
  //   });
  // }, []);

  useEffect(() => {
    (async () => {
      try {
        const resp = await openkit.data.findOne("c_stores", {
          type: "rentacar",
        });
        setStore(resp);
        setStores([resp]);
        setUserCategoryMaxHours(resp.max_reservation_time);
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  useEffect(() => {
    console.log("Setting car filter params");
    // set initial carFilterParams
    const { days } = timeRangeInDays(
      RENTACAR_CONSTANTS.DEFAULT_TIME_RANGE[0],
      RENTACAR_CONSTANTS.DEFAULT_TIME_RANGE[1]
    );

    // set villages so that the other suggestions (lodges, restaurants, etc) are related to the villages of pickup and return
    // since at launch, this service will only be available at Castelo Novo, villages are set to "castelo_novo"
    info.setVillages(["castelo_novo"]);

    if (days > 0)
      setCarFilterParams({
        ...carFilterParams,
        // FOR TESTING ONLY!!!!!
        typology: "resident",
        pickupLoc: "castelo_novo",
        returnLoc: "castelo_novo",

        // reservation_time_range is an array of date time strings
        reservation_time_range: [
          RENTACAR_CONSTANTS.DEFAULT_TIME_RANGE[0].format("YYYY-MM-DD HH:mm"),
          RENTACAR_CONSTANTS.DEFAULT_TIME_RANGE[1].format("YYYY-MM-DD HH:mm"),
        ],
        days,
        transferLoc: RENTACAR_CONSTANTS.TRANSFER_LOCS[0].value,
        transferTime: moment("10:00", "HH:mm"),
      });
  }, []);

  useEffect(() => {
    // request all vehicles with rentacar filter parameters
    (async () => {
      console.log("executou query");
      let cars = await searchVehicles(carFilterParams);

      // convert reservation time ranges from string
      // to array of objects with startDateTime and endDateTime
      // if (Object.keys(cars).length !== 0)
      if (cars?.length) {
        cars?.forEach((v) => {
          let ranges = v.reservation_time_ranges;
          ranges = ranges?.map((r) => {
            let startDateTimeStr = "";
            let endDateTimeStr = "";
            if (r) {
              let str = r?.replace("\\", "");
              startDateTimeStr = str.split('"')[1].toString();
              startDateTimeStr = startDateTimeStr.replace(/:[0-9][0-9]$/g, "");
              endDateTimeStr = str.split('"')[3].toString();
              endDateTimeStr = endDateTimeStr.replace(/:[0-9][0-9]$/g, "");
            }
            return {
              startDateTime: startDateTimeStr,
              endDateTime: endDateTimeStr,
            };
          });
          v.reservation_time_ranges = ranges;
        });

        setProducts(cars);

        // list of all available pickup and return locations
        let pickupLocations = [];
        let returnLocations = [];
        if (cars?.length) {
          cars.forEach((v) => {
            v.ren_pickup_locs.forEach((l) => pickupLocations.push(l));
            v.ren_return_locs.forEach((l) => returnLocations.push(l));
          });
          // use new Set to obtain unique return locations
          const uniquePickupLocations = [...new Set(pickupLocations)].map(
            (l) => ({ value: l, label: VILLAGES_OBJ[l] })
          );

          setPickupLocations(uniquePickupLocations);

          // // if there's only one pickup location, select it
          // uniquePickupLocations?.length === 1 &&
          //   setCarFilterParams({
          //     ...carFilterParams,
          //     pickupLoc: uniquePickupLocations[0].value,
          //   });

          // use new Set to obtain unique return locations
          const uniqueReturnLocations = [...new Set(returnLocations)].map(
            (l) => ({ value: l, label: VILLAGES_OBJ[l] })
          );

          setReturnLocations(uniqueReturnLocations);

          // // if there's only one pickup location, select it
          // uniqueReturnLocations?.length === 1 &&
          //   setCarFilterParams({
          //     ...carFilterParams,
          //     returnLoc: uniqueReturnLocations[0].value,
          //   });
        }
      } else {
        setProducts([]);
      }
    })();
  }, [
    carFilterParams.typology,
    pickupLocation,
    returnLocation,
    carFilterParams.reservation_time_range,
    carFilterParams.transferLoc,
    carFilterParams.transferTime,
    // info.rentacar
    info.refresh,
  ]);

  useEffect(() => {
    console.log("set Rentacar global");
    info.setRentacar({ ...carFilterParams });
  }, [carFilterParams]);

  function onOk(value) {
    console.log(value);
    const startDate = value[0]?._d;
    const endDate = value[1]?._d;

    if (!startDate || !endDate) return;

    const { start, end, days } = timeRangeInDays(value[0], value[1]);
    const hours = timeRangeInHours(value[0], value[1]);

    // reservation duration under max number of hours of the user type
    if (
      !info.user?.roles?.includes("admin") &&
      userCategoryMaxHours[carFilterParams.typology] < hours
    ) {
      // message.warning(
      //   `${info.t("maxPeriodExceeded")} ${info.t(carFilterParams.typology)}: ${
      //     userCategoryMaxHours[carFilterParams.typology]
      //   }`
      // );
      notification["error"]({
        message: info.t("attention"),
        description: `${info.t("maxPeriodExceeded")} ${info.t(
          carFilterParams.typology
        )}: ${userCategoryMaxHours[carFilterParams.typology]}`,
      });
      setCarFilterParams({
        ...carFilterParams,
        reservation_time_range: [null, null],
      });
      return;
    }

    if (days > 0)
      setCarFilterParams({
        ...carFilterParams,
        reservation_time_range: [start, end],
        days,
      });
  }

  function range(start, end) {
    const result = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  }

  return (
    <div style={{ marginTop: 10 }}>
      <div className="ahp-rentacar-category">
        <strong>{info.t("profile")}</strong>
        <Select
          // placeholder=""
          options={RENTACAR_CONSTANTS.TYPOLOGY.map((type) => ({
            value: type,
            label: info.t(type),
          }))}
          value={carFilterParams?.typology}
          onChange={(value) => {
            setCarFilterParams({ ...carFilterParams, typology: value });
          }}
          allowClear
          // style={{ width: FIELD_WIDTHS.L }}
          bordered={false}
          dropdownMatchSelectWidth={false}
        />
      </div>

      <strong>
        {info.t("maxAllowedReservationTimeRange")}:{" "}
        {userCategoryMaxHours[carFilterParams.typology]} {info.t("hours")}
      </strong>

      <div className="ahp-rentacar-category">
        <strong> {info.t("period")}</strong>
        <RangePicker
          showTime={{ format: "HH:mm", hideDisabledOptions: true }}
          showNow={false}
          format="YYYY-MM-DD HH:mm"
          onOk={onOk}
          // the default time range is from the next day at 10:00 to the following day at the same time
          defaultValue={RENTACAR_CONSTANTS.DEFAULT_TIME_RANGE}
          onChange={(value) =>
            value === null &&
            setCarFilterParams({
              ...carFilterParams,
              reservation_time_range: [null, null],
            })
          }
          disabledDate={(current) => disabledDates(current, carFilterParams)}
          disabledTime={(_, type) => {
            if (type === "start")
              return {
                disabledHours: () => [...range(0, 8), ...range(19, 23)],
                // disabledMinutes: () => range(30, 60),
              };
            if (type === "end")
              return {
                disabledHours: () => [...range(0, 8), ...range(19, 23)],
                // disabledMinutes: () => range(30, 60),
              };
          }}
          onOpenChange={() => {
            const timeTable = document.querySelector("li.ahp-timetable-text");
            if (!timeTable)
              setTimeout(() => {
                console.log("opened range picker");
                const rangePickerFooter = document.querySelector(
                  "ul.ant-picker-ranges"
                );
                console.log("rangePickerFooter", rangePickerFooter);
                const button = document.querySelector("li.ant-picker-ok");
                console.log("button", button);

                const timetable = document.createElement("li");
                timetable.className = "ahp-timetable-text";
                timetable.innerHTML = ReactDOMServer.renderToStaticMarkup(
                  <div>
                    <div style={{ fontWeight: 400 }}>
                      {info.t("serviceOnlyAvailableAtTime")}
                    </div>
                    <div style={{ fontWeight: 900 }}>
                      Posto de Turismo de Castelo Novo
                    </div>
                    <div style={{ fontWeight: 900 }}>
                      {info.t("winterWeekDays")}
                    </div>
                    <div style={{ fontWeight: 400 }}>
                      {info.t("winterTimetable")}
                    </div>
                    <div style={{ fontWeight: 400 }}>
                      {info.t("winterLunchBreak")}
                    </div>
                    <div style={{ fontWeight: 900 }}>
                      {info.t("summerWeekDays")}
                    </div>
                    <div style={{ fontWeight: 400 }}>
                      {info.t("summerTimetable")}
                    </div>
                    <div style={{ fontWeight: 400 }}>
                      {info.t("summerLunchBreak")}
                    </div>
                  </div>
                );

                button.parentNode.insertBefore(timetable, button.nextSibling);
              }, 500);
          }}
          // renderExtraFooter={() => (
          //   <div>
          //     <div style={{ fontWeight: 400 }}>
          //       {info.t("serviceOnlyAvailableAtTime")}
          //     </div>
          //     <div style={{ fontWeight: 900 }}>
          //       Posto de Turismo de Castelo Novo
          //     </div>
          //     <div style={{ fontWeight: 900 }}>{info.t("winterWeekDays")}</div>
          //     <div style={{ fontWeight: 400 }}>{info.t("winterTimetable")}</div>
          //     <div style={{ fontWeight: 400 }}>
          //       {info.t("winterLunchBreak")}
          //     </div>
          //     <div style={{ fontWeight: 900 }}>{info.t("summerWeekDays")}</div>
          //     <div style={{ fontWeight: 400 }}>{info.t("summerTimetable")}</div>
          //     <div style={{ fontWeight: 400 }}>
          //       {info.t("summerLunchBreak")}
          //     </div>
          //   </div>
          // )}
          bordered={false}
          allowClear
        />
        <div className="ahp-rentacar-pickup">
          <strong>{info.t("pickup")}</strong>

          <Select
            // placeholder={info.t("pickupAt")}
            options={pickupLocations}
            value={
              carFilterParams?.pickupLoc
              // ||
              // if there's only one location, show it
              // (pickupLocations?.length === 1 && pickupLocations[0].value)
            }
            onChange={(value) => {
              setCarFilterParams({ ...carFilterParams, pickupLoc: value });
              setPickupLocation(value);
              // set global villages so that suggestions are related to pickup village
              info.setVillages([value, pickupAndReturn[1]]);
              setPickupAndReturn([value, pickupAndReturn[1]]);
            }}
            // style={{ width: FIELD_WIDTHS.XL }}
            defaultActiveFirstOption={false}
            dropdownMatchSelectWidth={false}
            allowClear
            bordered={false}
          />
        </div>
        <div className="ahp-rentacar-return">
          <strong> {info.t("return")}</strong>

          <Select
            // placeholder={info.t("returnAt")}
            options={returnLocations}
            value={
              carFilterParams?.returnLoc
              // ||
              // if there's only one location, show it
              // (returnLocations?.length === 1 && returnLocations[0].value)
            }
            onChange={(value) => {
              setCarFilterParams({ ...carFilterParams, returnLoc: value });
              setReturnLocation(value);
              // set global villages so that suggestions are related to return village
              info.setVillages([pickupAndReturn[0], value]);
              setPickupAndReturn([pickupAndReturn[0], value]);
            }}
            // style={{ width: FIELD_WIDTHS.XL }}
            defaultActiveFirstOption={false}
            dropdownMatchSelectWidth={false}
            allowClear
            bordered={false}
          />
        </div>
        {(carFilterParams.typology === "visitor" ||
          carFilterParams.typology === "coworker") && (
          <div className="ahp-rentacar-return">
            <strong>{info.t("transfer")}</strong>
            <Select
              placeholder=""
              options={RENTACAR_CONSTANTS.TRANSFER_LOCS.map((tl) => ({
                label: info.t(tl.value),
                value: tl.value,
              }))}
              value={carFilterParams.transferLoc}
              onChange={(value) => {
                setCarFilterParams({ ...carFilterParams, transferLoc: value });
              }}
              // style={{ width: FIELD_WIDTHS.XL }}
              bordered={false}
              defaultActiveFirstOption={false}
              dropdownMatchSelectWidth={false}
            />
            {carFilterParams.transferLoc !== "no_transfer" && (
              <>
                <div className="ahp-rentacar-return">
                  {info.t("time")}:
                  <TimePicker
                    allowClear={false}
                    format={"HH:mm"}
                    bordered={false}
                    placeholder=""
                    showNow={false}
                    defaultValue={carFilterParams.transferTime}
                    onSelect={(value) =>
                      setCarFilterParams({
                        ...carFilterParams,
                        transferTime: value,
                      })
                    }
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
      {/* <ClearStateBtn
        text={info.t("clearFields")}
        stateAndSetStateArray={[
          { state: carFilterParams, setState: setCarFilterParams },
        ]}
      /> */}
    </div>
  );
}

export default RentacarFilter;
